'use strict';

angular.module('app').controller('SignUpController', SignUpController);
// .directive( 'emHeightTarget', function() {
//     return {
//         link: function( scope, elem, attrs ) {
//             scope.$watch( '__content_height', function( newHeight, oldHeight ) {
//                 console.info('old h - :', oldHeight, 'new h - :', newHeight);
//                 if(elem.prop('offsetHeight') < newHeight)
//                     elem.attr( 'style', 'height: ' + newHeight + 'px' );
//             } );
//         }
//     }
// } )
// .directive( 'emHeightSource', function() {
//     return {
//         link: function( scope, elem, attrs ) {
//             scope.$watch( function() {
//                 scope.__content_height = elem.prop('offsetHeight');
//             } );
//         }
//     }

// } );

SignUpController.$inject = [
  '$rootScope',
  '$routeParams',
  '$scope',
  '$window',
  '$translate',
  'UserService',
  '$location',
  '$timeout',
  'SelectService',
  '$uibModal',
  'blockUI',
  'SettingsService',
  'NotifyService',
  'BusinessService'];

function SignUpController(
    $rootScope, $routeParams, $scope, $window, $translate, UserService, $location, $timeout, SelectService, $uibModal, blockUI,
    SettingsService, NotifyService, BusinessService) {

  $scope.model = {
    name: '',
    login: '',
    password: '',
    country: '',
    phone: '',
    terms: false,
    pincode: '',
    type: 'business',
    step: 0,
    counter: 60
  };

  $scope.data = {
    //     videoLinks: [
    //         { lang: 'en', link: 'RvPYRX6Oomk'},
    //         { lang: 'uk', link: 'y7_x76J0Nq8'},
    //         { lang: 'ru', link: '90I16kVbU6w'}
    //     ]
  };
  $scope.CSRFToken = (Math.random() * 10000).toString(36);
  $scope.getCountriesList = SelectService.getCountriesList;
  $scope.getLocalizedPath = getLocalizedPath;

  $scope.inlineMessage = '';
  $scope.pincodeRequests = 0;
  $scope.phoneValid = false;
  $scope.isIncustPlatform = true;
  $scope.showEmailPin = false;
  $scope.showPhonePin = false;
  $scope.showPasswordField = false;

  $scope.IDENTIFIER_VERIFIED_EMAIL = {};
  $scope.IDENTIFIER_VERIFIED_PHONE = {};

  var block_register = blockUI.instances.get('registration');

  $window.ga('send', 'event', 'Business panel', 'Sing Up', 'Page View');

  $scope.getLegalLinks = function() {
    SettingsService.GetLegalLinks(function(success, response) {
      if (success) {
        $scope.terms_of_service_url = response.terms_of_service_url;
        $scope.privacy_policy_url = response.privacy_policy_url;
        $scope.terms_of_service_business_url = response.terms_of_service_business_url;
      }
    });
  };

  validateHost();
  $scope.getLegalLinks();
  initController();

  var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
    $scope.getCountriesList();
  });

  $scope.$on('$destroy', unbindTranslateChangeSuccess);

  function validateHost() {
    $scope.isIncustPlatform = appConfig.platformParams.main_site.en === 'incust.com';
  }

  function initController() {
    // console.info('navigator: ', navigator)
    initFieldsValues();
    $scope.getCountriesList();
  }

// osben9999@gmail.com
  //12345678
  function initFieldsValues() {
    for (var i in $routeParams)
      $scope.model[i] = $routeParams[i];
  }

  function resendCodeTime() {
    $scope.pincodeRequests++;

    if ($scope.pincodeRequests < 2) {
      $scope.model.counter = 60;
      $scope.onTimeout = function() {
        if ($scope.model.counter == 1) {
          $scope.resentPincodeTimeout = true;
          $timeout.cancel(smsTimeout);
        } else {
          $scope.model.counter--;
          smsTimeout = $timeout($scope.onTimeout, 1000);
        }
      };
      var smsTimeout = $timeout($scope.onTimeout, 1000);
    }
  }

  $scope.loginSuccessHandler = function(success, response) {

    if (success) {
      BusinessService.Get(function(success, data) {
        if (success && data) {
          UserService._storeUserPublic(response.user);
          $rootScope.$broadcast('user-login');
          if ($rootScope.USER.language) {
            $rootScope.LANG = $rootScope.USER.language;
            $translate.use($rootScope.USER.language);
          }
          //$analytics.eventTrack('Sing In', {  category: 'Login', label: 'Business panel' });
          $window.ga('send', 'event', 'Business panel', 'Sing In', 'Login');

          var query = $location.search();
          var pathTo = query.redirect ? query.redirect : '/';
          $location.path(pathTo);

          // Remove query parameter
          $location.search('redirect', null);
          $scope.inlineMessage = undefined;

        } else {
          // show accept license agreements
          $location.path('/signin').search({userIn: response.user});
        }

      });

      block_register.stop();
    } else {
      var isInlineMessage = response.code == 1 || response.code == 2 || response.code == 4 || response.code == 5;
      if (isInlineMessage) {
        $scope.inlineMessage = response.message;
      }
      block_register.stop();
    }
  };

  $scope.Login = function(form) {

    if (form.login.$valid && form.password.$valid) {
      form.login.$dirty = true;
      $scope.inlineMessage = '';
      var post_data = {
        login: $scope.model.login,
        password: $scope.model.password
      };
      block_register.start();
      UserService.Loginv2(post_data, $scope.loginSuccessHandler);

    } else {
      form.login.$dirty = true;

      $scope.inlineMessage = '';
    }
  };
  $scope.setNewPassword = function() {
    $location.path('/signin').search({setPassword: $scope.model.login});
  };
  /**
   * Send request for gets pin-code for email validation
   */
  $scope.requestEmailPinAndVerify = function() {
    var post_data = {
      value: $scope.model.login.trim(),
      pin: $scope.model.pincode
    };
    block_register.start();
    UserService.emailVerify(post_data, function(success, response) {
      if (success) {
        if (response.code === 0 && !response.token) {
          $scope.model.pincode = '';
          $scope.showEmailPin = true;
          $scope.pincodeRequests = 0;
          resendCodeTime();
        } else {
          $scope.showEmailPin = false;
          $scope.model.step = 1;
          $scope.model.pincode = '';
          $scope.IDENTIFIER_VERIFIED_EMAIL = response;
        }

      } else {
        if (response.code !== 151 && response.code !== 26 && response.code !== 27) {

          NotifyService.Error(response.message, false);
        }
        if (response.code === 26) {
          $scope.showPasswordField = true;
        }

      }
      block_register.stop();

    });
  };
  /**
   * Send request for gets pin-code for phone validation
   */
  $scope.isVerifiedPhone = true;
  $scope.requestPhonePinAndVerify = function() {
    var post_data = {
      value: $scope.model.phone,
      pin: $scope.model.pincode
    };

    if ($scope.IDENTIFIER_VERIFIED_EMAIL && $scope.IDENTIFIER_VERIFIED_EMAIL.token) {
      post_data.token = $scope.IDENTIFIER_VERIFIED_EMAIL.token;
    }

    SettingsService.GetPlatformParams(function(success, response) {
      var isVerifiedPhone = true;
      var regionCodeForNumber = getCountryCodeByPhone($scope.model.phone);
      console.log('regionCodeForNumber', regionCodeForNumber);
      if (!regionCodeForNumber && $scope.model.phone.indexOf('+38011') != -1) {
        regionCodeForNumber = 'UA';
      }
      if (success && regionCodeForNumber) {
        isVerifiedPhone = !!response.user_phone_verification_allowed_rules.general.verified;
        if (!!response.user_phone_verification_allowed_rules.countries &&
            !!response.user_phone_verification_allowed_rules.countries.length) {
          var specCountry = (response.user_phone_verification_allowed_rules.countries || []).find(function(country) {
            return country.country == regionCodeForNumber;
          });
          console.log('specCountry', specCountry);
          if (specCountry) {
            isVerifiedPhone = !!specCountry.rule.verified;
          }
        }
      }

      block_register.start();
      if (isVerifiedPhone === false) {
        UserService.validatePhone(post_data, function(success, response) {
          if (success) {
            if (response.code === 0) {
              $scope.showPhonePin = false;
              $scope.model.step = 2;
              $scope.model.pincode = '';
              // $scope.IDENTIFIER_VERIFIED_PHONE = response
            } else {
              NotifyService.Error(response.message, false);
            }

          } else {
            if (response.code !== 25) {
              NotifyService.Error(response.message, false);
            }
          }
          block_register.stop();
        });
      } else {
        UserService.phoneVerify(post_data, function(success, response) {
          if (success) {
            if (response.code === 0 && !response.token) {
              $scope.showPhonePin = true;
              $scope.model.pincode = '';
              $scope.pincodeRequests = 0;
              resendCodeTime();
            } else {
              $scope.showPhonePin = false;
              $scope.model.step = 2;
              $scope.model.pincode = '';
              $scope.IDENTIFIER_VERIFIED_PHONE = response;
            }

          } else {
            if (response.code !== 25) {
              NotifyService.Error(response.message, false);
            }
          }
          block_register.stop();

        });
      }
    });
  };

  $scope.register = function(form, step) {
    var post_data;

    switch (step) {
      case 0:
        if (
            form.login.$valid
        ) {

          $scope.requestEmailPinAndVerify();
        } else {
          form.username.$dirty = form.login.$dirty
              = form.password.$dirty
              = form.terms.$dirty
              = true;
        }
        break;
      case 1:
        if ($scope.phoneValid) {
          $scope.requestPhonePinAndVerify();
        } else {
          form.phone.$dirty = true;
        }
        break;
      case 2:
        if (form.username.$valid && form.password.$valid && form.terms.$valid) {

          post_data = {
            name: $scope.model.name,
            login: $scope.IDENTIFIER_VERIFIED_EMAIL.token,
            password: $scope.model.password,
            country: $scope.model.country,
            phone: (($scope.IDENTIFIER_VERIFIED_PHONE && $scope.IDENTIFIER_VERIFIED_PHONE.token)
                ? $scope.IDENTIFIER_VERIFIED_PHONE.token
                : $scope.model.phone) || null,
            pin: $scope.model.pincode,
            type: 'business'
          };

          block_register.start();

          UserService.Registerv2(post_data, function(success, response) {
            // TODO обработать code === 0 выслали пин-код
            if (success) {

              UserService._storeUserPublic(response);
              $rootScope.$broadcast('user-register');
              if ($routeParams['redirect']) {
                $location.path($routeParams['redirect']);
                $location.search({redirect: null});
              } else if ($routeParams['ref'])
                $location.path('/business/create?ref=' + $routeParams['ref']);
              else {
                $location.path('/business/create');
              }

              $window.ga('send', 'event', 'Business panel', 'Sing Up', 'Registration');
            } else {
              var isInlineMessage = response.code == 1 || response.code == 2 || response.code == 4 || response.code == 5;
              if (isInlineMessage) {
                $scope.inlineMessage = response.message;
              }
            }
            block_register.stop();
          });
        } else {
          form.terms.$dirty = true;
          form.password.$dirty = true;
          form.username.$dirty = true;
        }
        break;
    }

  };

  $scope.onBackClick = function(step) {
    $scope.model.step = step;
    $scope.inlineMessage = '';

    if ($scope.pincodeRequests > 1 && step === 1) {
      $scope.resentPincodeTimeout = false;
      $scope.model.counter = 60;
    }
  };

  $scope.onRemoveInlineMessageClick = function() {
    $scope.inlineMessage = '';
  };

  $scope.onPhoneChange = function() {
    if ($scope.model.phone && isPhoneValid($scope.model.phone)) {
      $scope.phoneValid = true;
      $scope.checkIsRequiredPhone();
    } else {
      $scope.phoneValid = false;
    }
  };
  $scope.isRequiredPhone;
  $scope.checkIsRequiredPhone = function() {
    console.log('checkIsRequiredPhone');

    SettingsService.GetPlatformParams(function(success, response) {
      console.log('checkIsRequiredPhone::GetPlatformParams', success, response);
      if (success) {
        // default value isRequiredPhone
        $scope.isRequiredPhone = !!response.user_register_with_phone_rules.general.required;

        if ($scope.model.country && !!response.user_register_with_phone_rules.countries &&
            !!response.user_register_with_phone_rules.countries.length) {
          var specCountry = (response.user_register_with_phone_rules.countries || []).find(function(country) {
            return country.country == $scope.model.country;
          });
          console.log('specCountry', specCountry, $scope.model.country);
          if (specCountry) {
            $scope.isRequiredPhone = !!specCountry.rule.required;
          }
        }
      }

    });
  };

  $scope.onPasswordGenerate = function(form) {
    var pwd = angular.element('input[id="password"]');
    pwd.attr('type', 'text');

    var specials = '#$&*()_[]~';
    var lowercase = 'abcdefghijklmnopqrstuvwxyz';
    var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var numbers = '0123456789';
    var all = specials + lowercase + uppercase + numbers;

    var password = '';
    password += pickCharacter(specials, 1);
    password += pickCharacter(lowercase, 1);
    password += pickCharacter(uppercase, 1);
    password += pickCharacter(numbers, 1);
    password += pickCharacter(all, 11, 12);
    password = shufflePassword(password);

    $scope.model.password = password;
    form.password.$dirty = true;
  };

  function pickCharacter(str, min, max) {
    var n, chars = '';

    if (typeof max === 'undefined')
      n = min;
    else
      n = min + Math.floor(Math.random() * (max - min + 1));

    for (var i = 0; i < n; i++)
      chars += str.charAt(Math.floor(Math.random() * str.length));

    return chars;
  };

  function shufflePassword(str) {
    var array = str.split('');
    var tmp, current, top = array.length;

    if (top) while (--top) {
      current = Math.floor(Math.random() * (top + 1));
      tmp = array[current];
      array[current] = array[top];
      array[top] = tmp;
    }

    return array.join('');
  };

  $scope.onContactMeClick = function() {
    UserService.SendToSupport($scope.model, 'PIN-CODE NOT RECEIVED', function(success, response) {
      if (success) {
        var modalInstance = $uibModal.open({
          animation: true,
          keyboard: true,
          templateUrl: 'app/templates/modal.auth.support.tpl.html',
          controller: function($scope, $uibModalInstance) {
            $scope.onReplyOK = function() {
              $uibModalInstance.dismiss('cancel');
            };
          }
        });
      }
    });
  };

  $rootScope.$watch('COUNTRIES[LANG]', function(newValue, oldValue, scope) {
    var lang = $rootScope.LANG;

    if (newValue) {
      $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[lang]);

      var l = $scope.data.countriesList;
      for (var i in l)
        if (l[i].current)
          $scope.data.currentCountry = l[i];

      if (!$scope.data.currentCountry)
        $scope.data.currentCountry = l[0];
    }
  }, true);

  $scope.$watch('data.currentCountry', function(newValue, oldValue) {
    if (newValue) {
      $scope.model.country = $scope.data.currentCountry.code;
      if (!$scope.phoneValid) {
        $scope.model.phone = $scope.data.currentCountry.phone_prefix;
      }

      $scope.checkIsRequiredPhone();

      // TODO вытянуть параметры из user_phone_verification_allowed_rules по коду страны или взять general
      // anonymous true - игнорируем
      // authorized true - игнорируем
      // verified  true
      // verified === true -> верифицировать телефон как сейчас
      // verified === false

    }
  }, true);

  $scope.$watchCollection('[model.name, model.login, model.password, model.phone, model.terms, model.pincode]',
      function(newValues, oldValues) {
        $scope.inlineMessage = '';
      });

}
